/**
 * Created by MinhQuan on 12/17/2015.
 */
angular.module('common.template.measure.popup',['common.filter.description']).controller('MeasurePopupController',
    function(CONSTANTS, $uibModalInstance, measureExtendedInfo){
        var measurePopupCtrl = this;
        measurePopupCtrl.measureType = measureExtendedInfo.measureType;
        measurePopupCtrl.startDate = measureExtendedInfo.startDate;
        measurePopupCtrl.implicitEndDate = measureExtendedInfo.implicitEndDate;
        measurePopupCtrl.regulationRetros = measureExtendedInfo.regulationRetros;
        measurePopupCtrl.measureRetros = measureExtendedInfo.measureRetros;
        measurePopupCtrl.taxCodes = measureExtendedInfo.taxCodes;
        measurePopupCtrl.preferenceCodes = measureExtendedInfo.preferenceCodes;
        measurePopupCtrl.hasEndUseProcedureCode44 = measureExtendedInfo.hasEndUseProcedureCode44;
        measurePopupCtrl.preuccPreferenceCodes = measureExtendedInfo.preuccPreferenceCodes;
        measurePopupCtrl.dateFormat = CONSTANTS.dateFormat;
        measurePopupCtrl.close = function (){
            $uibModalInstance.dismiss('Close');
        };
});



// WEBPACK FOOTER //
// ./app/common/popup/measure/measure-popup.js